import './css/main.css';
import './../css/checkbox.css'
import $ from 'jquery';
import axios from 'axios';
import React, { useState, useEffect } from 'react';

const initialPageInfo = {
  page: 'companies',
}

const initialUserInfo = {
  firstName: '',
  lastName: '',
  country: '',
  city: '',
  email: '',
  phoneNumber:'',
  postalCode: '',
  streetAddress: '',
  targetedMarketing:'',
  superUser:'',
  newsLetterSubscription:'',
  companyName: '',
  companyID: ''
}

const EditCompany = ({ company, onSave, onDelete, onCustomerEmailAdd, onCustomerEmailDelete }) => {
  const [editedCompany, setEditedCompany] = useState({ 
    id: company.id || '',
    name: company.name || '',
    VAT_number: company.VAT_number || '',
    OVT_number: company.OVT_number || '',
    streetAddress: company.streetAddress || '',
    postnumber: company.postnumber || '',
    city: company.city || '',
    country: company.country || '',
    phone: company.phone || '',
    email: company.email || '',
    paymentType: company.paymentType || '',
    contactPerson: company.contactPerson || ''
  });

  const [isEditMode, setIsEditMode] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany({ ...editedCompany, [name]: value });
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleSave = () => {
    onSave(editedCompany);
    setIsEditMode(false);
  };

  const handleDelete = () => {
    onDelete(company.id);
  };

  
  const handleDeleteCustomerEmail = (companyID, email) => {
    onCustomerEmailDelete(companyID, email);
  };

  const handleAddNewCustomerEmail = (companyID) => {
    const newEmail = editedCompany.newCustomerEmail.trim();
    onCustomerEmailAdd(companyID, newEmail)
  };

  return (
    <div  className="form-container-company">
      <div className='h1'>{editedCompany.name}</div>
      <div>
        <label>Yrityksen nimi: * </label>
        <input type="text" name="name" value={editedCompany.name} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>ALV-tunnus: *</label>
        <input type="text" name="VAT_number" value={editedCompany.VAT_number} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>OVT-tunnus: </label>
        <input type="text" name="OVT_number" value={editedCompany.OVT_number} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Lähiosoite: *</label>
        <input type="text" name="streetAddress" value={editedCompany.streetAddress} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Postinumero: *</label>
        <input type="text" name="postnumber" value={editedCompany.postnumber} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Paikkakunta: *</label>
        <input type="text" name="city" value={editedCompany.city} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Maa: *</label>
        <input type="text" name="country" value={editedCompany.country} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Puhelinnumero: *</label>
        <input type="text" name="phone" value={editedCompany.phone} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Sähköpostiosoite: *</label>
        <input type="text" name="email" value={editedCompany.email} onChange={handleChange} disabled={!isEditMode} />
      </div>
      <div>
        <label>Maksutapa: *</label>
        <select name="paymentType" value={editedCompany.paymentType} onChange={handleChange} disabled={!isEditMode}>
          <option value="invoice">Lasku</option>
          <option value="paytrail">Paytrail</option>
        </select>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label style={{ fontWeight: 'bold' }}>Asiakassähköpostit:</label>
        <div style={{ marginTop: '5px' }}>
          <table>
            <tbody>
              {company.customerEmails && company.customerEmails.split(',').map(email => (
                <tr key={email}>
                  <td>{email}</td>
                  <td>
                    <button onClick={() => handleDeleteCustomerEmail(company.id, email)} style={{ backgroundColor: 'red', color: 'white' }}>Poista</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '10px' }}>
            <input type="email" name="newCustomerEmail" placeholder="Lisää asiakassähköposti" onChange={handleChange} disabled={!isEditMode} style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc', marginRight: '10px' }} />
            <button onClick={() => handleAddNewCustomerEmail(company.id)} disabled={!isEditMode}>Lisää</button>
          </div>
        </div>
      </div>

       {isEditMode ? (
        <>
          <button onClick={handleSave} style={{ backgroundColor: 'green', color: 'white' }}>Tallenna</button>
          <button onClick={() => setIsEditMode(false)} style={{ backgroundColor: 'gray', color: 'white' }}>Peruuta</button>
        </>
      ) : (
        <>
          <button onClick={handleEdit} style={{ backgroundColor: 'blue', color: 'white', marginRight: "5px" }}>Muokkaa</button>
          <button onClick={handleDelete} style={{ backgroundColor: 'red', color: 'white' }}>Poista</button>
        </>
      )}
    </div>
  );
};

const getEmptyCompany = () => ({
  id: '',
  name: '',
  VAT_number: '',
  OVT_number: '',
  streetAddress: '',
  postnumber: '',
  city: '',
  country: '',
  phone: '',
  email: '',
  paymentType: '',
  contactPerson: ''
});


const AddCompanyForm = ({ onSave }) => {
  const [newCompany, setNewCompany] = useState(getEmptyCompany());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCompany({ ...newCompany, [name]: value });
  };

  const handleSave = () => {
    if (!newCompany.name || !newCompany.VAT_number || !newCompany.streetAddress || !newCompany.postnumber || !newCompany.city || !newCompany.country || !newCompany.phone || !newCompany.email) {
      alert('Täytä kaikki pakolliset kentät (merkitty *) ennen tallentamista.');
      return; // Stop further execution
    }
    onSave(newCompany);
    setNewCompany(getEmptyCompany()); // Clear the form after saving
  };

  return (
    <div  className="form-container-company">
      <h4>Lisää uusi yritys</h4>
      <div>
        <label>Yrityksen nimi: *</label>
        <input type="text" name="name" value={newCompany.name} onChange={handleChange} required/>
      </div>
      <div>
        <label>ALV-tunnus: *</label>
        <input type="text" name="VAT_number" placeholder="FI33811422" value={newCompany.VAT_number} onChange={handleChange} required/>
      </div>
      <div>
        <label>OVT-tunnus: </label>
        <input type="text" name="OVT_number" value={newCompany.OVT_number} onChange={handleChange} />
      </div>
      <div>
        <label>Lähiosoite: *</label>
        <input type="text" name="streetAddress" value={newCompany.streetAddress} onChange={handleChange} required/>
      </div>
      <div>
        <label>Postinumero: *</label>
        <input type="text" name="postnumber" value={newCompany.postnumber} onChange={handleChange} required/>
      </div>
      <div>
        <label>Paikkakunta: *</label>
        <input type="text" name="city" value={newCompany.city} onChange={handleChange} required/>
      </div>
      <div>
        <label>Maa: *</label>
        <input type="text" name="country" value={newCompany.country} onChange={handleChange} required/>
      </div>
      <div>
        <label>Puhelinnumero: *</label>
        <input type="text" name="phone" value={newCompany.phone} onChange={handleChange} required/>
      </div>
      <div>
        <label>Sähköpostiosoite: *</label>
        <input type="text" name="email" value={newCompany.email} onChange={handleChange} required/>
      </div>
      <div>
        <label>Maksutapa: *</label>
        <select name="paymentType" value={newCompany.paymentType} onChange={handleChange}>
          <option value="invoice">Lasku</option>
          <option value="paytrail">Paytrail</option>
        </select>
      </div>
      <div>
        <label>Yhteyshenkilö: </label>
        <input type="text" name="contactPerson" placeholder='Myöhemmin...' onChange={handleChange} disabled/>
      </div>

      <button onClick={handleSave} style={{ backgroundColor: 'green', color: 'white' }}>Tallenna</button>
    </div>
  );
};



const Companies = props => {
  const [userProfile, updateUserProfile] = useState(initialUserInfo)
  const callCustomerBackend = "https://" +  window.location.hostname + "/php/controllers/Customer.php";
  const callCompanyBackend = "https://" +  window.location.hostname + "/php/controllers/Company.php";
  const [pageInfo, updatePageInfo] = useState(initialPageInfo)
  const [companies, setCompanies] = useState([]);
  //console.log(callCustomerBackend)


  const fetchData = async () => {
    try {
      const response = await axios.post(callCompanyBackend, {
        'function': 'getCompanies',
        "authToken": props.user.signInUserSession.accessToken.jwtToken
      });
      if (response.data.status === "200") {
        // Assuming company data is stored in response.data.content array
        setCompanies(response.data.content);
      } else {
        $('.content').html('Virhe profiilia ladattaessa');
      }
    } catch (error) {
      console.error('Error:', error);
      $('.content').html('Virhe profiilia ladattaessa');
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);


  useEffect(() => {
    const post_data = {
      'function' : 'user',
      "authToken" : props.user.signInUserSession.accessToken.jwtToken
    }

    axios.post(callCustomerBackend, post_data)
    .then(result => {
        //console.log(result.data)
        if (result.data.status === "200"){
          updateUserProfile(() => ({
            firstName: result.data.content[0].firstName,
            lastName: result.data.content[0].lastName,
            city: result.data.content[0].city,
            email: result.data.content[0].email,
            country: result.data.content[0].Country,
            phoneNumber:result.data.content[0].phoneNumber,
            postalCode: result.data.content[0].postalCode,
            streetAddress: result.data.content[0].streetAddress,
            targetedMarketing: result.data.content[0].targetedMarketing,
            newsLetterSubscription : result.data.content[0].newsLetterSubscription,
            companyName: result.data.content[0].companyName,
            companyID: result.data.content[0].companyID,
            superUser: result.data.content[0].superUser

          }))
        }
        else{
          $('.content').html('Virhe profillia ladattaessa')
        }
    })
    .catch(error => function(){
      console.log('error:' + error)
      $('.content').html('Virhe profillia ladattaessa')
    })
  }, []);


  const ScrollToTheTop = () => {
     window.scrollTo(0, 0)
  }

  const handleEditCompany = (editedCompany) => {
    handleSaveEditedCompany(editedCompany);
    // Implement logic to save the edited company information
  };



  const handleAddNewCompany = async (newCompany) => {
    
    try {
      const response = await axios.post(callCompanyBackend, {
        function: 'addCompany',
        authToken: props.user.signInUserSession.accessToken.jwtToken,
        companyData: newCompany
      });
      if (response.data.status === "200") {
        console.log('Company added successfully');
        // Optionally, you can fetch the updated companies data here
        fetchData(); // Assuming fetchData function fetches companies data from the backend
      } else {
        console.error('Error adding company:', response.data.message);
        // Handle error case
      }
    } catch (error) {
      console.error('Error adding company:', error);
      // Handle error case
    }
    
  }

  const handleSaveEditedCompany = async (editedCompany) => {
    try {
      const response = await axios.post(callCompanyBackend, {
        function: 'updateCompany',
        authToken: props.user.signInUserSession.accessToken.jwtToken,
        companyData: editedCompany
      });
      if (response.data.status === "200") {
        console.log('Company updated successfully');
        // Optionally, you can fetch the updated companies data here
        fetchData(); // Assuming fetchData function fetches companies data from the backend
      } else {
        console.error('Error updating company:', response.data.message);
        // Handle error case
      }
    } catch (error) {
      console.error('Error updating company:', error);
      // Handle error case
    }
  };

  

  const handleDeleteCompany = async (companyId) => {
    try {
      // Ask for confirmation
      const isConfirmed = window.confirm('Oletko varma, että haluat poistaa tämän yrityksen?');
  
      // Proceed if the user confirms
      if (isConfirmed) {
        const response = await axios.post(callCompanyBackend, {
          function: 'deleteCompany',
          authToken: props.user.signInUserSession.accessToken.jwtToken,
          companyId: companyId
        });
  
        if (response.data.status === "200") {
          console.log('Company deleted successfully');
          // Refresh the companies list
          fetchData();
        } else {
          console.error('Error deleting company:', response.data.message);
          // Handle error case
        }
      } else {
        console.log('Toiminto on peruttu. Yritystä ei poistettu.');
      }
    } catch (error) {
      console.error('Error deleting company:', error);
      // Handle error case
    }
  };
  


  const handleCustomerEmailDelete = async (companyID, customerEmail) => {

    try {
      // Ask for confirmation
      const isConfirmed = window.confirm('Oletko varma, että haluat poistaa tämän yrityksen?');
      
      if (isConfirmed) {
        const response = await axios.post(callCompanyBackend, {
          function: 'deleteCustomerEmail',
          authToken: props.user.signInUserSession.accessToken.jwtToken,
          companyID: companyID,
          customerEmail: customerEmail
        });
        if (response.data.status === "200") {
          console.log('Customer email deleted  successfully');
          fetchData(); 
        } else {
          console.error('Error adding company:', response.data.message);
        }
      } else {
        console.log('Toiminto on peruttu. Yrityksen käyttäjä ei poistettu.');
      }
    } catch (error) {
      console.error('Error adding company:', error);
    }
  
  }

  const handleCustomerEmailAdd = async (companyID, customerEmail) => {

    try {
      const response = await axios.post(callCompanyBackend, {
        function: 'addCustomerEmail',
        authToken: props.user.signInUserSession.accessToken.jwtToken,
        companyID: companyID,
        customerEmail: customerEmail
      });
      if (response.data.status === "200") {
        console.log('Customer email added  successfully');
        fetchData(); 
      } else {
        console.error('Error adding company:', response.data.message);
      }
    } catch (error) {
      console.error('Error adding company:', error);
    }
  
  }

  

  //console.log(userProfile)
  
  return(
    <div className="inline">
      {
        pageInfo.page === 'loading' && (
          <div className="content">
          <div className="breadcrumb"><div onClick={event => props.onChange('landing')}>Oma eKukka</div> &gt; </div>
          <div className="h1">Omat tiedot</div>
            {
              userProfile.superUser === 0 ? (
                <div>Not allowed</div>
              ) : (
                <div>Ladataan profiilia...</div>
              )
            }
          </div>
        )
      }
      {
        userProfile.superUser === 0 && (
          <div className="content width100">
            {ScrollToTheTop()}
            <div className="h4">Sinulla ei ole oikeus tälle sivulle.</div>
          </div>
        )
      }

      {
        pageInfo.page === 'companies' && userProfile.superUser === 1 && (
          <div className="content width100">
            {ScrollToTheTop()}

            {/* Render the AddCompanyForm component */}
            <AddCompanyForm onSave={handleAddNewCompany} />
            <hr />

          
            <h4>Lisätty yritykset</h4>
            {companies.map((company) => (
              <div key={company.id}>
                <EditCompany company={company} onSave={handleEditCompany} onDelete={handleDeleteCompany} onCustomerEmailAdd={handleCustomerEmailAdd} onCustomerEmailDelete={handleCustomerEmailDelete}  />
              </div>
            ))}
          </div>
        )
      }
    </div>
  )
}
export default Companies;
